import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

export const weekDays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
export const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
export const weekDaysFull = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];


export const minutesOptions = ['00', '30'];
export const hoursLimit = {
    min: 0,
    max: 30
};
export const timeOptions = {
    hours: 'hours',
    minutes: 'minutes',
};
export const timeErrors = {
    hours: 'Часы должны быть числом от 0 до 23',
    minutes: 'Минуты должны быть 00 или 30',
};

dayjs.locale('ru')
dayjs.extend(customParseFormat)
dayjs.extend(utc)